import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-password-field',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './password-field.html',
  styleUrl: './password-field.css'
})
export class PasswordField {
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() control: FormControl<any> | null = null;
  @Input() hasError: boolean = false;
  @Input() value: string = '';
  @Input() customClass = '';
  @Input() errorMessage: string = '';

  showPassword = false;

  toggleVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  get inputType(): string {
    return this.showPassword ? 'text' : 'password';
  }

  get showError(): boolean {
    return !!(
      this.control &&
      this.control.invalid &&
      (this.control.touched || this.control.dirty)
    );
  }

}
